// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"8b74f15c","455":"d2da9438","977":"59883df8"}[chunkId] + ".chunk.js";
};